//GeneratorFlag:[NoChange]
import PersonReal from './person-real';

export default {PersonReal}
export{PersonReal}